
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Toaster } from "@/components/ui/toaster";
import { useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Toaster as SonnerToaster } from "sonner";
import { DailyGreetingPage } from "./greeting/DailyGreetingPage";
import { useDailyGreeting } from "@/hooks/useDailyGreeting";

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const { shouldShowGreeting, dismissGreeting } = useDailyGreeting();
  
  const isInterview = location.pathname === "/interview";
  const isJobHunt = location.pathname.startsWith("/job-hunt");
  const isResumeBuilder = location.pathname.includes("/resume-builder");
  const isResumeEditor = location.pathname.includes("/resume-builder/editor/");
  const isResumeBuilderCreate = location.pathname.includes("/resume-builder/create");
  const isCoverLetter = location.pathname.includes("/resume-builder/cover-letter/");
  const isCareerIntro = location.pathname.startsWith("/career-discovery/intro");
  const isHomepage2 = location.pathname === "/homepage2" || location.pathname === "/";
  const isAuthPage = location.pathname === "/auth";
  const isForInstitutions = location.pathname === "/for-institutions";
  const isInterviewLanding = location.pathname === "/try-interview";
  
  // Don't show greeting on auth page
  const showGreeting = shouldShowGreeting && !isAuthPage;

  // Show full-page greeting if needed
  if (showGreeting) {
    return <DailyGreetingPage onDismiss={dismissGreeting} />;
  }
  
  return (
    <div className="min-h-screen flex flex-col bg-background">
      {!isHomepage2 && !isForInstitutions && !isInterviewLanding && <Header />}
      <main className={cn(
        "flex-1",
        isResumeBuilderCreate || isResumeEditor || isCoverLetter || isHomepage2 || isForInstitutions || isInterviewLanding
          ? "p-0 max-w-none w-full overflow-hidden m-0"
          : isInterview || isJobHunt
          ? "p-0 max-w-none w-full"
          : (isResumeBuilder && !isResumeEditor)
          ? `w-full max-w-[1200px] mx-auto px-4 sm:px-6 ${isCareerIntro ? "pt-6 pb-2" : "py-8"}`
          : `container mx-auto px-4 ${isCareerIntro ? "pt-6 pb-2" : "py-8"}`
      )}>
        {children}
      </main>
      {!isResumeEditor && !isHomepage2 && !isForInstitutions && !isInterviewLanding && <Footer />}
      <Toaster />
      <SonnerToaster position="bottom-right" closeButton richColors />
    </div>
  );
}
